import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { inr } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const discount = product.mrp && product.mrp > product.price
    ? Math.round(((product.mrp - product.price) / product.mrp) * 100) : 0;

  return (
    <Card data-testid={`product-card-${product.id}`} className="group overflow-hidden border-slate-200/80 dark:border-slate-800 hover:shadow-lg transition-all duration-200">
      <div className="relative aspect-square overflow-hidden bg-slate-100">
        <img src={product.image} alt={product.name} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        {product.on_deal && (
          <span className="absolute top-2 left-2 bg-orange-600 text-white text-[10px] font-bold px-2 py-1 rounded-full">DEAL</span>
        )}
        {discount > 0 && (
          <span className="absolute top-2 right-2 bg-yellow-400 text-slate-900 text-[10px] font-bold px-2 py-1 rounded-full">-{discount}%</span>
        )}
      </div>
      <div className="p-4 space-y-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-yellow-700 dark:text-yellow-400">{product.category}</span>
        <h3 className="font-heading font-semibold text-sm leading-snug line-clamp-2 min-h-[2.5rem]">{product.name}</h3>
        <div className="flex items-baseline gap-2">
          <span className="font-heading font-bold text-lg">{inr(product.price)}</span>
          {product.mrp && <span className="text-xs text-muted-foreground line-through">{inr(product.mrp)}</span>}
          <span className="text-xs text-muted-foreground ml-auto">{product.unit}</span>
        </div>
        <Button data-testid={`add-to-cart-${product.id}`} onClick={() => { add(product); toast.success(`${product.name} added`); }}
          className="w-full bg-yellow-400 hover:bg-yellow-500 text-slate-900 h-9">
          <Plus className="w-4 h-4 mr-1" /> Add
        </Button>
      </div>
    </Card>
  );
}
